// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import '@/theme/element-#FCC604/index.css'
import router from './router'
import store from './store/'
import { createi18n } from './i18n'
import '@/assets/style/phoneInput.less'
Vue.config.productionTip = false

Vue.use(ElementUI)
const i18n = createi18n()
/* eslint-disable */
new Vue({
  el: '#app',
  store,
  router,
    i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js